import React, {Component} from 'react';
import './Error.css';
import {connect} from 'react-redux';
import Button from './Button';
import {actions} from '../error.state';
import Modal from 'react-modal';

class Error extends Component {
	render() {
		const {error} = this.props;
		const {title, message} = (error || {});
		
		return (
			<div className="Error-wrapper">
				<Modal
					className="Error"
					overlayClassName="Error-overlay"
					isOpen={!!(title || message)}
					onRequestClose={this.props.closeError}
					contentLabel={title}
				>
					<h2>{title}</h2>
					<div className="Error-content">
						{message && message.includes(';') ? message.split(';').map(m => <p>{m}</p>) : <p>{message}</p>}
					</div>
					<div className="Error-actions">
						<Button onClick={this.props.closeError}>close</Button>
					</div>
				</Modal>
			</div>
		);
	}
}

const ConnectedError = connect(
	state => ({
		error: state.error
	}),
	dispatch => ({
		closeError: () => dispatch(actions.errorClear())
	})
)(Error);

export default ConnectedError;


// WEBPACK FOOTER //
// ./src/widgets/Error.js